import React from 'react';
import LandingMediaKitProposal from '../TNOMediaKitProposal';

/**
 * Vista estática de Merpoeste en ruta corta: /merpoeste
 */
const LandingMediaKitMerpoeste = (props) => (
  <LandingMediaKitProposal
    {...props}
    staticOnly
    forcedSlug="merpoeste"
  />
);

export default LandingMediaKitMerpoeste;
